import { Check, Ruler } from "lucide-react";
import { Reveal } from "../landing/shared";
import { SITE, IMAGES } from "@/config";

const FEATURES = [
  "Foldable design",
  "Anti-skid base",
  "Comfortable footrest",
  "Compact bathroom design",
  "Easy to clean",
  "Built-in air freshener slot",
];

const GALLERY = [
  { src: IMAGES.antiskid, alt: "Anti-skid rubber base of the Medlinkx footstool" },
  { src: IMAGES.footrest, alt: "Comfortable textured foot rest of the Medlinkx footstool" },
  { src: IMAGES.freshener, alt: "Built-in air freshener slot of the Medlinkx footstool" },
];

const Features = () => (
  <section data-testid="product-features-section" className="bg-ivory py-14 sm:py-20">
    <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-14 lg:px-8">
      <Reveal className="grid grid-cols-3 gap-3 sm:gap-4">
        {GALLERY.map(({ src, alt }, i) => (
          <div key={src} className={`relative overflow-hidden rounded-2xl sm:rounded-3xl ${i === 1 ? "mt-6 sm:mt-10" : ""}`}>
            <img
              src={src}
              alt={alt}
              data-testid={`features-image-${i + 1}`}
              className="aspect-square w-full object-cover"
            />
          </div>
        ))}
      </Reveal>

      <div>
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">The footstool</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-serif text-3xl leading-[1.12] tracking-tight text-navy sm:text-4xl" data-testid="features-headline">
            Made for Everyday Bathrooms.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-7 space-y-3.5" data-testid="features-list">
            {FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-3 text-base font-medium text-charcoal/85">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy">
                  <Check className="h-3.5 w-3.5 text-gold" strokeWidth={3} />
                </span>
                {f}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="mt-8">
          <div
            data-testid="features-dimensions"
            className="inline-flex items-center gap-3 rounded-2xl border border-gold/35 bg-white px-5 py-4"
          >
            <Ruler className="h-5 w-5 text-gold" />
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-charcoal/50">Dimensions</p>
              <p className="font-serif text-xl font-semibold text-navy">{SITE.productDimensions}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Features;
